import React from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadPartner, } from '../../../actions/room';
import { fetchConToken } from '../../../helpers/fetch';
import { useForm } from '../../../hooks/useForm';

export const Lista = () => {
    const cliente = useSelector(state => state.client);
    const pagos = useSelector(state => state.payments);
    const {list} = useSelector(state => state.rooms);
    const {sinHabitacion} = useSelector(state => state.rooms);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadPartner());
    }, [dispatch]);


    const [{clienteSelect}, handleInputChange, reset] = useForm({
        clienteSelect: ''
    });

    const handleAddParner = async () => {
        console.log(clienteSelect);
        const resp = await fetchConToken(`habitacion/addcompanero/${clienteSelect}`);
        const data = await resp.json();
        console.log(data);
        if(!data.ok){
            // setValid(false);
        } else{
            // setParametros(data.data);
            // setValid(true);
            dispatch(loadPartner());
        }
        // setLoading(false);
    }

    return (
        <div>
            <table className="table mt-4">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Cliente</th>
                        <th scope="col" className="text-right">Pagado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">1</th>
                        <td>{cliente.nombre} {cliente.ape_paterno} {cliente.ape_materno}</td>
                        <td className="text-right">{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(pagos.total) }</td>
                    </tr>
                    {list.map((clienteLista, id) => (
                        <tr key={id}>
                            <th scope="row">{id+2}</th>
                            <td>{clienteLista.nombre} {clienteLista.ape_paterno} {clienteLista.ape_materno}</td>
                            <td className="text-right">{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(clienteLista.total) }</td>
                    </tr>
                    ))}
                    <tr>
                        <td colSpan={3} >
                            {
                                cliente.paquete.habitaciones == 1 &&
                                    list.length < 4 &&
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col">
                                                <select 
                                                    className="custom-select form-control mr-3"
                                                    name="clienteSelect"
                                                    onChange={handleInputChange}
                                                    value={clienteSelect}
                                                >
                                                    <option value=""> -- Selecciona -- </option>
                                                    {sinHabitacion.map((partner) => <option value={partner.folio} key={partner.folio}>{partner.nombre} {partner.ape_paterno} {partner.ape_materno}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-1 mt-2">
                                                <i 
                                                    role="button" 
                                                    className="text-primary fa fa-plus-circle" 
                                                    style={{fontSize: '2.5em'}}
                                                    onClick={handleAddParner}
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
            
        </div>
    )
}
